import './div.css'

function Outlined() {
    return (
        <div className='div'>
            
        </div>
    )
}

export default Outlined
